/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 04.07.13, 10:25
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */


import { IdentityManagementConstants } from "../constants/IdentityManagementConstants";

import Event = createjs.Event;

export class IdentityManagementLicenseEvent extends Event {
    public static SHOW_LICENSE_INITIAL_AGE_RATING_TEXT: string = "showLicenseInitialAgeRatingText";
    public static SHOW_LICENSE_LOGOS: string = "showLicenseLogos";
    public static HIDE_LICENSE: string = "hideLicense";
    public static HIDE_NICE_ID_DIALOG: string = "hideNiceIDDialog";

    public initialAgeRatingTextId: string = IdentityManagementConstants.TEXT_ID_INITIAL_AGE_RATING_INFO;

    constructor(type: string, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);
    }
}

